/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemAggregationsResultsSchema } from './itemAggregationsResultsSchema';

export const itemAggregationResponseSchema = z.object({
  get data() {
    return z.array(itemAggregationsResultsSchema);
  },
});
